import React from 'react';
import { Modal, ModalContent, Text } from '@cashfree-intl/coherent';

import CustomIcon from 'components/CustomIcons';

const RechargePendingModal = () => (
  <Modal open $maxWidth={480}>
    <ModalContent className="p-4">
      <div className="text-center">
        <CustomIcon componentName="SAND_TIMER" />
        <Text variant="h16" className="mt-3" color="bodyLight">
          It usually takes <span className="w-600">20-30</span> mins to reflect
          the <br />
          money in the wallet. We will update you <br /> once recharge is
          successful.
        </Text>
      </div>
    </ModalContent>
  </Modal>
);

export default RechargePendingModal;
